export const labelToAnchor = (label: string) => {
  return label
    .replace(/\s+|\//g, "-")
    .replace(/-{2,}/g, "-")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};
